import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import axios from "axios";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, Pagination } from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";
import PageSpinner from "../PageSpinner";
import Banner from "../common/banner";
import { renderInput, renderTextArea, renderDatePicker, renderMultiselect, renderCheckbox } from "../common/renderinput";

import appConfig from '../../config/config';

class PropertyReportTaxComment extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: '', IsDataLoaded: false, OrderData: {}
        };
    }
    closeBanner = () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    submit = (values) => {
        axios.post(
            appConfig.apiGateway.updatePropertyReport,
            JSON.stringify({
                ...values, OrderId: this.props.OrderId,
                OrderProductId: this.props.OrderProductId,
                Action: "Tax",
                UserName: this.props.session.session.user.name
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => {
            if (response.data.Count > 0) {
                var myObject = JSON.parse(response.data.body);
                this.props.dispatch(reset('propertyReportTaxForm'))
            }
        },
            (error) => {
                this.setState(state => ({ ...state, message: error, showBanner: true }));

            });

    }
    selectRow(Id) {
    }
    render() {
        return (
            <>
            <form onSubmit={this.props.handleSubmit(this.submit)} style={{ marginLeft: "0%", marginRight: "5%" }}>
            <div className="form-row col-12 pl-0 " >
                    <div className="col-12" >
                        <Field name="Comments" component={renderTextArea} label="Comments" isLabel={true} />
                    </div>
                </div>
                <div className="col-12 pb-2 text-right">
                    <Button color="primary" type="submit" className="mr-3">Save</Button>
                    <Button type="button">Cancel</Button>
                </div>
            </form>

            </>
        );
    }
}

const validate = (formValues) => {
    const errors = {};

    return errors;
}
var propertyReportTaxForm = reduxForm({
    form: 'propertyReportTaxForm',
    validate
})(PropertyReportTaxComment);

propertyReportTaxForm = connect(
    state => ({
        session: state.session
    })
)(propertyReportTaxForm);

export default propertyReportTaxForm;